var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('time',{class:_vm.$style.time,attrs:{"title":_vm.$fmt.date(_vm.start, 'PPpp z', { local: _vm.isLocal }),"datetime":_vm.dateTime}},[_vm._v("\n  "+_vm._s(_vm.rangeString)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }